import { Component, OnInit, ViewChild, ElementRef, ViewEncapsulation, Input } from '@angular/core';
import { IUProperty } from 'src/app/shared/interface/umbraco-property';
import { IPanelSettings } from '../lib/public_api';
import { GoogleMap } from '@angular/google-maps';
import { animate, state, style, transition, trigger } from '@angular/animations';
interface IMapPanelData {
  apiKey: IUProperty<string>;
  title: IUProperty<string>;
  description: IUProperty<string>;
  panelsSettings: IPanelSettings;
  markers: IUProperty<IMapMarker[]>;
}
interface IMapMarker {
  name: string;
  description: string;
  location: {lat: number, lng: number}
}
@Component({
  selector: 'section[ubl-map-panel]',
  templateUrl: './map-panel.component.html',
  styleUrls: ['./map-panel.component.less'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'map-panel'
  },
  animations: [
    trigger('fadeIn', [
      state('in', style({opacity: 1})),

      transition(':enter', [
        style({opacity: 0}),
        animate(600 )
      ]),

      transition(':leave',
        animate(600, style({opacity: 0})))
    ])
  ]
})
export class MapPanelComponent implements OnInit {
  static googleMapScriptLoaded: boolean;

  @Input() data: IMapPanelData;

  showMap: boolean;
  markers: IMapMarker[];
  center = [];
  bounds: google.maps.LatLngBounds;

  @ViewChild('map', {static: false}) set mapRef(map: GoogleMap)
  {
    if (!map) return;

    this.bounds = new google.maps.LatLngBounds();
    this.markers.forEach(m => this.bounds.extend(m.location));

    map.fitBounds(this.bounds);
  }

  ngOnInit()
  {
    this.markers = this.data.markers.value || [];

    if (!window.hasOwnProperty('google'))
    {
      this.loadGoogleMapScript();
    } else {
      this.showMap = true;
    }
  }

  private loadGoogleMapScript()
  {
    const url=`https://maps.googleapis.com/maps/api/js?key=${this.data.apiKey}`
    const script = document.createElement('script');

    script.src = url;

    script.onload = () => this.showMap = true;

    document.head.appendChild(script);
  }
}


